export default {"src":"/_next/static/media/arrow.8db4068d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};